const style = ({ theme }) => ({
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: theme.colors.background.body.default
})

export default style
